










import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';

@Component({})
export default class FinancialNumberInput extends Vue {
    static COMPONENT_NAME = 'financial-number-input'

    @Prop({type: [Number, String], default: null}) readonly value!: number | string | null

    handleInput(val: number | string | null): void {
        this.$emit('input', this.parseValue(val))
    }

    parseValue(val: number | string | null): number | string | null {
        if (val === null || val === undefined || val === '') {
            return null;
        }

        const numeric = Number(val);

        return isFinite(numeric) ? numeric : val as string;
    }
}
